import { render } from "./CopyPaste.vue?vue&type=template&id=1b15ace9"
import script from "./CopyPaste.vue?vue&type=script&lang=js"
export * from "./CopyPaste.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__